const tracks = {
  piano: {
    a: {
      title: 'Heater-1',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3',
    },
    s: {
      title: 'Heater-2',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3',
    },
    d: {
      title: 'Heater-3',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3',
    },
    f: {
      title: 'Heater-4',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-4_1.mp3',
    },
    g: {
      title: 'Clap',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-6.mp3',
    },
    h: {
      title: 'Open-hh',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Dsc_Oh.mp3',
    },
    j: {
      title: 'Kick-n-Hat',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3',
    },
    k: {
      title: 'Kick',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/RP4_KICK_1.mp3',
    },
    l: {
      title: 'Closed-hh',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Cev_H2.mp3',
    },
  },
  heater: {
    a: {
      title: 'Chord-1',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_1.mp3',
    },
    s: {
      title: 'Chord-2',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_2.mp3',
    },
    d: {
      title: 'Chore-3',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_3.mp3',
    },
    f: {
      title: 'Give us a Light',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Give_us_a_light.mp3',
    },
    g: {
      title: 'Open-hh',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Dry_Ohh.mp3',
    },
    h: {
      title: 'Closed-hh',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Bld_H1.mp3',
    },
    j: {
      title: 'Punchy-Kick',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/punchy_kick_1.mp3',
    },
    k: {
      title: 'Side-Stick',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/side_stick_1.mp3',
    },
    l: {
      title: 'Snare',
      src: 'https://s3.amazonaws.com/freecodecamp/drums/Brk_Snr.mp3',
    },
  },
};

export default tracks;
